import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetDirectorNotificationsUseCaseInterface } from 'domain/usecases';

export class RemoteGetDirectorNotifications
  implements GetDirectorNotificationsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetDirectorNotificationsUseCaseInterface.Result>,
  ) {}

  async execute(
    params?: GetDirectorNotificationsUseCaseInterface.Params,
  ): Promise<GetDirectorNotificationsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        page: params?.page,
        length: params?.length,
        status: params?.status || 'ALL',
        organizationHashIds: params?.organizationHashIds,
        courseHashIds: params?.courseHashIds,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
